import axios from "axios";
import * as d3 from "d3";
import {colonAnnotation, fw_progressive_1way, numberFormat, tooltip_class} from '../functions'

export default function (chart, divId, vizName) {
    var url = '/api/fetchData/' + chart.data.syspk + '/' + vizName

    console.log("Chart vizName called:", vizName)

    let x1AxisLabel = d3.scaleLinear().range([chart.margin.left, chart.width - chart.margin.right]);
    let xMin = 0, xMax = 0, rectSize = 100;
    let y1AxisLabel, y2AxisLabel, bars, metric1ColorScale, gradient, metric2ColorScale, y1legend, minLegend,
        maxLegend;
    let checked = true, input = "basedOnInput";

    function responsivefy(svg) {
        var container = d3.select(svg.node().parentNode),
            width = parseInt(svg.style("width")),
            height = parseInt(svg.style("height")),
            aspect = width / height;

        svg.attr("viewBox", "0 0 " + width + " " + height)
            .attr("perserveAspectRatio", "xMinYMid")
            .call(resize);

        d3.select(window).on("resize." + container.attr("id"), resize);

        function resize() {
            var targetWidth = parseInt(container.style("width"));
            svg.attr("width", targetWidth / 1.2);
            svg.attr("height", Math.round(targetWidth / 1.2 * aspect));
        }
    }

    function performYAxisTransition() {
        svg.select(".y.axis")
            .transition()
            .duration(900)
            .call(y2AxisLabel);
    }

    function performXAxisTransition() {
        svg.select(".x.axis")
            .transition()
            .duration(900)
            .call(d3.axisBottom(x1AxisLabel)
                .tickSizeInner(-(chart.height - chart.margin.top - chart.margin.bottom))
                .ticks(15, ".0f")
                .tickSizeOuter(0));
    }

    function performBarsTransition() {
        bars.transition()
            .duration(900)
            .attr("x", function (d) {
                return x1AxisLabel(d.start);
            })
            .attr("y", function (d) {
                return y1AxisLabel(d.dim1_name);
            })
            .attr("width", function (d) {
                return x1AxisLabel(d.end) - x1AxisLabel(d.start);
            })
            .attr("height", y1AxisLabel.bandwidth())
            .attr("rx", 4)
            .attr("ry", 4)
            .attr("fill", (d) => {
                return metric1ColorScale(d.start - d.end)
            });
    }

    function createBars(ds) {
        bars = svg.selectAll(".bars")
            .data(ds)
            .enter()
            .append("rect");
    }

    function createLegend() {
        gradient = svg.append("defs")
            .append("linearGradient")
            .attr("id", "gradient")
            .attr("x1", "0%")
            .attr("y1", "0%")
            .attr("x2", "100%")
            .attr("y2", "0%")
            .attr("spreadMethod", "pad");

        gradient.append("stop")
            .attr("offset", "0%")
            .attr("stop-color", "#2f4b7c")
            .attr("stop-opacity", 1);

        gradient.append("stop")
            .attr("offset", "33%")
            .attr("stop-color", "#a05195")
            .attr("stop-opacity", 1);

        gradient.append("stop")
            .attr("offset", "75%")
            .attr("stop-color", "#f95d6a")
            .attr("stop-opacity", 1);

        gradient.append("stop")
            .attr("offset", "100%")
            .attr("stop-color", "#ffa600")
            .attr("stop-opacity", 1);

        metric2ColorScale = svg.append("rect")
            .attr("x", ((chart.margin.left + (chart.width - chart.margin.right)) / 2) - rectSize)
            .attr("y", chart.height - 20)
            .attr("width", rectSize)
            .attr("height", 8)
            .attr("rx", 4)
            .attr("ry", 4)
            .style("fill", "url(#gradient)");

        y1legend = svg.append("text")
            .attr("text-anchor", "middle")
            .attr("x", (chart.margin.left + (chart.width - chart.margin.right)))
            .attr("y", chart.height - 24)
            .attr("class", "legend")
            .attr("font-family", "Lato")
            .text("Color legend");

        minLegend = svg.append("text")
            .attr("text-anchor", "end")
            .attr("x", ((chart.margin.left + (chart.width - chart.margin.right)) / 2) - rectSize - 4)
            .attr("y", chart.height - 13)
            .attr("class", "legend")
            .text("Minimum");

        maxLegend = svg.append("text")
            .attr("text-anchor", "start")
            .attr("x", ((chart.margin.left + (chart.width - chart.margin.right)) / 2) + rectSize + 4)
            .attr("y", chart.height - 13)
            .attr("class", "legend")
            .attr("font-family", "Lato")
            .text("Maximum");
    }

    function updateYScale() {
        y1AxisLabel = d3.scaleBand()
            .range([chart.margin.top, chart.height - chart.margin.bottom])
            .paddingInner(0.4)
            .paddingOuter(0.4);
    }

    function updateYAxis() {
        y2AxisLabel = d3.axisLeft(y1AxisLabel).tickSizeOuter(0)
    }

    updateYScale();
    updateYAxis();

    let x2AxisLabel = d3.axisBottom(x1AxisLabel)
        .tickSizeInner(-(chart.height - chart.margin.top - chart.margin.bottom))
        .ticks(6)
        .tickSizeOuter(0)
        .tickPadding(6);

    let svg = d3.select(divId).select("svg").remove();
    svg = d3.select(divId)
        .append("svg")
        .attr("width", chart.width)
        .attr("height", chart.height)
        .call(responsivefy)
        .append('g')
        .attr('transform', 'translate(' + chart.margin.left + ',' + chart.margin.top + ')');

    let inputFrom = d3.select("#from");
    let inputTo = d3.select("#to");

    let xTitle = svg.append("text")
        .attr("class", "axisTitle")
        .attr("text-anchor", "middle")
        .attr("y", (chart.height - chart.margin.bottom) + 34)
        .attr("x", (chart.margin.left + (chart.width - chart.margin.right)) / 2)
        .text("Time (Years)");

    axios.get(url).then(res => {
        let data = res.data;
        data.forEach(function (d) {
            let dim2_name = d.dim2_name;
            if (dim2_name.includes("-")) {
                d.start = +dim2_name[0];
                d.end = +dim2_name[1];
                if (!dim2_name.includes("present")) {
                    let start = +dim2_name;
                    let end = +dim2_name;
                    d.dim2_name = Math.max(end - start, 1);
                }
            } else {
                d.start = +dim2_name.split("-")[0];
                d.end = +dim2_name.split("-")[1];
                d.start = +dim2_name;
                d.end = (+dim2_name) + 1;
                d.dim2_name = 1;
            }
        });

        data.forEach(function (d) {
            d.metric1 = +d.metric1;
        });

        let dataSet = data;
        let x1colorScale = [-90, -75, -45, -25, -8, -5, 0];
        metric1ColorScale = d3.scaleLinear().domain(x1colorScale).range(fw_progressive_1way);

        createBars(dataSet);

        let gX = svg.append("g")
            .attr("class", "x axis")
            .attr("transform", `translate(0,${chart.height - chart.margin.bottom})`)
            .call(x2AxisLabel);

        let gY = svg.append("g")
            .attr("class", "y axis")
            .attr("transform", `translate(${chart.margin.left},0)`)
            .call(y2AxisLabel);

        console.warn("gY", gY)

        gX.lower();

        createLegend();

        d3.selectAll(".sort").on("click", function () {
            let thisClicked = this.value;
            drawSort(thisClicked);
        });

        d3.selectAll(".since").on("click", function () {
            input = this.value;
            redraw();
        });

        d3.select("#checkbox").on("change", function () {
            checked = !checked;
            redraw()
        });

        createListeners();

        function createListeners() {
            // why two tooltips
            d3.select(".d3-tip" + divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
            let y1tip = tooltip_class()
            y1tip.attr('class', 'd3-tip' + divId.id)
                .html((d) => {
                    let filteredData = dataSet.filter(function (e) {
                        return e.dim1_name === d
                    })[0];
                    return (`${filteredData.dim3_name}${colonAnnotation} ${filteredData.dim1_name}`)
                })

            svg.call(y1tip);

            let y2tip = tooltip_class()

            y2tip.attr('class', 'd3-tip' + divId.id)
                .html(function (d) {
                    return (`${d.dim3_name}: <br>
                        ${d.dim1_name}${colonAnnotation} ${d.metric1 === 0 ? "Unknown" : numberFormat(d.metric1)}<br>`
                    )
                })

            svg.call(y2tip);
            d3.selectAll(".y.axis text").on("mousemove", y1tip.show).on("mouseout", y1tip.hide)

            bars.on("mousemove", y2tip.show).on("mouseout", y2tip.hide)
        }

        redraw();

        function drawSort(sort) {
            if (sort === "sortTotalDeathToll") {
                dataSet.sort(function (a, b) {
                    return d3.descending(a.metric1, b.metric1);
                });
            } else if (sort === "sortStartYear") {
                dataSet.sort(function (a, b) {
                    return d3.ascending(a.start, b.start);
                });
            } else if (sort === "sortTotalSpan") {
                dataSet.sort(function (a, b) {
                    return d3.descending(a.dim2_name, b.dim2_name);
                });
            }

            y1AxisLabel.domain(dataSet.map(function (d) {
                return d.dim1_name;
            }));

            bars.transition()
                .duration(900)
                .attr("y", function (d) {
                    return y1AxisLabel(d.dim1_name);
                });

            performYAxisTransition();
        }

        function redraw() {
            dataSet = data;
            let filteredDataset = [];
            if (checked) {
                for (const d of data) {
                    if (d.metric1 !== 0) {
                        filteredDataset.push(d)
                    }
                }
            } else {
                filteredDataset = data;
            }

            if (input === "all") {
                if (checked) {
                    dataSet = filteredDataset;
                }
                x1AxisLabel.domain([
                    d3.min(dataSet, function (d) {
                        return d.start;
                    }),
                    d3.max(dataSet, function (d) {
                        return d.end;
                    })
                ]);
            } else if (input === "basedOnInput") {
                xMin = +inputFrom.property("value");
                xMax = +inputTo.property("value");
                dataSet = [];
                for (const d of filteredDataset) {
                    if (d.start < xMin && d.end > xMin) {
                        d.start = xMin;
                    }
                    if (d.end > xMin && d.end <= xMax) {
                        dataSet.push(d)
                    }
                }
                x1AxisLabel.domain([
                    xMin,
                    +inputTo.property("value"),
                ]);
            }

            bars.data([]).exit().remove();  // Remove all rows

            createBars(dataSet);  // Add all currently selected rows back in
            updateYScale();
            updateYAxis();

            y1AxisLabel.domain(dataSet.map(function (d) {
                return d.dim1_name;
            }));

            performBarsTransition();
            performXAxisTransition();
            performYAxisTransition();
            createListeners();

            svg.attr("height", chart.height);
            d3.select(divId).attr("height", chart.height);

            xTitle.attr("y", (chart.height - chart.margin.bottom) + 34);

            gX.attr("transform", "translate(0," + (chart.height - chart.margin.bottom) + ")");

            y1legend.attr("x", (chart.margin.left + (chart.width - chart.margin.right)) / 2).attr("y", chart.height - 24);
            minLegend.attr("y", chart.height - 13);
            maxLegend.attr("x", ((chart.margin.left + (chart.width - chart.margin.right)) / 2) + rectSize + 4).attr("y", chart.height - 13);
            metric2ColorScale.attr("x", ((chart.margin.left + (chart.width - chart.margin.right)) / 2) - rectSize).attr("y", chart.height - 20);
        }
    }).catch(function (error) {
        if (error) throw error;
    });
}
